// frontend/src/components/UI/ProtectedRoute.jsx - FIXED for Team Members
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Loader from "./Loader";

const ProtectedRoute = ({
  children,
  adminOnly = false,
  superAdminOnly = false,
  teamMemberOnly = false,
  requireFarmer = false,
  requireSupplier = false,
  requireCustomer = false,
  requireTeamRole = null,
  requirePermission = null,
}) => {
  const {
    user,
    loading,
    isAdmin,
    isSuperAdmin,
    isTeamMember,
    isStaff,
    isFarmer,
    isCustomer,
    isSupplier,
    isPendingApproval,
    hasPermission,
    getEffectiveRole,
  } = useAuth();
  const location = useLocation();

  if (loading) return <Loader />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // If the user is not active
  if (user.isActive === false) {
    return (
      <Navigate
        to="/login"
        state={{ error: "Account deactivated", from: location.pathname }}
        replace
      />
    );
  }

  // If the user is pending approval - still allow access but show pending message
  if (isPendingApproval()) {
    // For dashboard, allow access with limited features
    // For other routes, redirect to dashboard
    if (location.pathname === "/dashboard") {
      return children;
    }
    return <Navigate to="/dashboard" replace />;
  }

  // Super Admin check
  if (superAdminOnly && !isSuperAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  // Admin check
  if (adminOnly && !isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  // Team Member check - FIXED: Allow all team members
  if (teamMemberOnly) {
    // Check if user is a team member OR admin OR super admin
    if (!isTeamMember() && !isAdmin() && !isSuperAdmin()) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Farmer check
  if (requireFarmer && !isFarmer()) {
    return <Navigate to="/dashboard" replace />;
  }

  // Supplier check
  if (requireSupplier && !isSupplier()) {
    return <Navigate to="/dashboard" replace />;
  }

  // Customer check
  if (requireCustomer && !isCustomer()) {
    return <Navigate to="/dashboard" replace />;
  }

  // Team Role check
  if (requireTeamRole) {
    const effectiveRole = getEffectiveRole();
    if (effectiveRole !== requireTeamRole && !isAdmin() && !isSuperAdmin()) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Permission check
  if (requirePermission && !hasPermission(requirePermission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
